<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="idsLocaisFaturamentos"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
  (isFirstOpened)="firstOpened($event)">
</sgt-multi-select>
